"use strict";
var Observable_1 = require('../../Observable');
var toArray_1 = require('../../operator/toArray');
Observable_1.Observable.prototype.toArray = toArray_1.toArray;
//# sourceMappingURL=toArray.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/~/rxjs/add/operator/toArray.js
// module id = ../../../../rxjs/add/operator/toArray.js
// module chunks = 3